import { createContext } from 'react';
import type { RouteScreenData } from '../schema/MiniRouteScreen.types';

export const RouteScreenContext = createContext<RouteScreenData>({});
